import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { SITE, IMG } from "@/lib/site";
import Chapter from "@/components/cinema/Chapter";
import { Reveal, LineReveal } from "@/components/cinema/Reveal";

export default function FinalCtaChapter() {
  return (
    <Chapter img={IMG.stageBackHome} overlay="dark" testId="home-cta">
      <div className="absolute top-0 left-0 right-0 h-1 ember-stripe siren-sweep" />
      <div className="text-center text-white flex flex-col items-center">
        <Reveal y={12}><div className="live-pill mb-8"><span className="dot"></span> We're on call</div></Reveal>
        <LineReveal
          delay={0.15}
          className="display-chunky text-5xl md:text-7xl xl:text-[6.5rem] max-w-5xl leading-[0.9] mb-10"
          lines={["One call.", "One trusted team.", <span className="text-[hsl(var(--gaza-crimson-bright))]">Calm in the chaos.</span>]}
        />
        <Reveal delay={0.6}>
          <p className="text-white/75 max-w-2xl mx-auto text-lg leading-relaxed">
            From emergency response and contents protection to storage, moving and final pack-back, BackHome delivers a coordinated recovery from the first call to the last box back in place.
          </p>
        </Reveal>
        <Reveal delay={0.8}>
          <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
            <a href={SITE.phoneHref} className="btn-gold" data-testid="cta-call-btn"><Phone className="w-4 h-4" /> Call {SITE.phone}</a>
            <Link to="/contact" className="btn-outline" data-testid="cta-contact-btn">Send a Message <ArrowRight className="w-4 h-4" /></Link>
          </div>
        </Reveal>
      </div>
    </Chapter>
  );
}
